import { cn } from "../../lib/cn";

// インライン読み込みインジケータ（CTA 内・センター配置どちらでも使う）。
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        "inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent",
        className,
      )}
    />
  );
}
